export enum CertificationType {
  Kowhai = 0,
  Hiriwa,
  Kahurangi
}
